import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DonationForm',
  props: [
  "currencies",
  "amounts",
  "strings",
  "show_currency_dropdown",
  "show_amounts",
  "custom_amount",
  "show_recurring",
  "symbols",
  "symbol",
  "display_amount"
],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const {amount, currency, recurring } = store;
const props = __props;
const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key, val) => {
  store[key] = val;
};
const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol
};
const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation
  const syb = store.currency

  if(_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt
};


onMounted(() => {
  if(props.show_amounts && _.size(props.amounts)) {
    setValue('amount', props.amounts[0])
  }
  if(props.show_currency_dropdown && _.size(props.currencies)) {
    setValue('currency', _.keys(props.currencies)[0])
  }
  if (props.display_amount) {
    store.amount = props.display_amount;
  }
});



const __returned__ = { store, amount, currency, recurring, props, lifeline_donation, _, setValue, getSymbol, convert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})